import React, { useCallback, useState, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import SystemDialog from "./SystemDialog";
import { fetchAPIData, getCompanyId, getToken, getUser, cleanObject, generateHiddenColumns, hasPermission, HIDDEN_SECRET, hideSecret, platformManage, platformPermissionOptions,createFilterOptions, createSortFieldOptions } from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Ajv from "ajv";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import './system.scss';
const systemIdpOAuth2SchemaRequired = require("../../json/idpOAuth2Schema.json").create.required;
const systemIdpOAuth2SchemaUpdate = require("../../json/idpOAuth2Schema.json").update;

const ajv = new Ajv({ strict: false });

const uiSchema = {
  "clientSecret": {
    "ui:widget": "password",
    "ui:autocomplete": "new-password"
  },
  "clientId": {
    "ui:autocomplete": "off"
  }
};

const SystemIdpOAuthTabPanel = ({ createIdpOAuth, setOpenIdpOAuth, setNotify }) => {
  const { permissions } = usePermissionContext();
  const [apiData, setApiData] = useState({});
  const [rowJsonData, setRowJsonData] = useState({});
  //const [formData, setFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('view');  // default to view mode

  const [readOnly, setReadOnly] = useState(false);
  const [reload, setReload] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const [confirmProps, setConfirmProps] = useState({});

  const [originalClientSecret, setOriginalClientSecret] = useState(""); // store original client secret

  const formId = 'CreateSystemDialog';
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    if (createIdpOAuth) {
      handleClickOpen();
    }
  }, [createIdpOAuth]);

  const handleClickOpen = () => {
    let rowData = {};
    const JsonData = rowData;
    setRowJsonData(JsonData);
    setMode('create');
    setOpen(true);
    setReadOnly(false);
  };


  const handleClose = () => {
    setOpen(false);
    setOpenIdpOAuth(false);
  };

  const [idpOAuth2, setIdpOAuth2] = usePersistentStorage("idpOAuth2", []);

  useEffect(() => {
    // check if localstorge had data for the current tab
    setApiData(idpOAuth2);
  }, []);

  const fieldData = [
    'clientId', 'idpType', 'accessTokenUri', 'userAuthorizationUri', 'jwkUrl'
  ];

  const hasPlatformManage = hasPermission(permissions, platformManage);

  const sortFieldData = [
    // {
    //   field: 'companyId',
    //   label: 'Company ID'
    // },
    {
      field: 'clientId',
      label: 'Client ID'
    },
    {
      field: 'idpType',
      label: 'Type'
    },
    {
      field: 'accessTokenUri',
      label: 'Access Token Uri'
    },
    {
      field: 'userAuthorizationUri',
      label: 'User Authorization Uri'
    },
    {
      field: 'jwkUrl',
      label: 'JWK URL'
    }
  ];

  const totalLabel = "Matching IDP-OAuth";

  const getActionButtons = (params) => {
    let actionButtons = [];

    let editButton = <GridActionsCellItem icon={
      <Tooltip title="Edit" arrow placement="right">
        <EditIcon />
      </Tooltip>}
      label='View/Edit'
      onClick={viewEditData(params.row)}
    />;

    hasPlatformManage && getUser().toLowerCase() === 'irmuser_idp_admin' && actionButtons.push(editButton);

    let deleteButton = <GridActionsCellItem icon={
      <Tooltip title="Delete" arrow placement="right">
        <DeleteIcon />
      </Tooltip>}
      label='Delete'
      onClick={deleteRowData(params.row)}
    />;

    hasPlatformManage && getUser().toLowerCase() === 'irmuser_idp_admin' && actionButtons.push(deleteButton);

    return actionButtons;

  };

  const columns = [
    // {
    //   field: 'id',
    //   type: 'number',
    //   headerName: 'ID',
    //   hide: true,
    //   minWidth: 50,
    //   flex: 1,
    //   headerAlign: 'left',
    //   align: 'left',
    // },
    {
      hideable: false,
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      minWidth: 120,
      maxWidth: 120,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      getActions: (params) => getActionButtons(params)
    },
    {
      hideable: false,
      field: 'companyId',
      headerName: 'Company ID',
      type: 'number',
      minWidth: 100,
      maxWidth: 100,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) => {
        return params.value.toString();
      }
    },
    {
      hideable: false,
      field: 'clientId',
      headerName: 'Client ID',
      minWidth: 545,
      maxWidth: 545,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      hideable: false,
      field: 'idpType',
      headerName: 'Type',
      minWidth: 200,
      maxWidth: 200,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    },
    {
      hideable: false,
      field: 'accessTokenUri',
      headerName: 'Access Token Uri',
      renderCell: renderCellExpand,
      minWidth: 190,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      hideable: false,
      field: 'userAuthorizationUri',
      headerName: 'User Authorization Uri',
      renderCell: renderCellExpand,
      minWidth: 190,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
    },
    {
      hideable: false,
      field: 'jwkUrl',
      headerName: 'Jwk URL',
      minWidth: 190,
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      renderCell: renderCellExpand,
    }
  ];

  const getColumns = () => {
    return ((hasPlatformManage && getUser() === 'irmuser_idp_admin') && columns) || columns.filter(obj => { return obj.field !== "actions"});
  };

  const toggleColumnPinning = () => {
      return ((hasPlatformManage && getUser() === 'irmuser_idp_admin') && 'columnPinning') || '';
  };

  const viewEditData = useCallback((rowData) => () => {
    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = rowData;

    setOriginalClientSecret(JsonData.clientSecret);

    let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

    formattedData.clientSecret = hideSecret(formattedData.clientSecret);

    setRowJsonData(formattedData);
    setMode('edit');
    setReadOnly(false);
    setOpen(true);
  }, []);

  const viewRowData = (param, event) => {

    // remove the id from table data as table data only not part of json stored
    const {
      id,
      ...JsonData
    } = param.row;

    setOriginalClientSecret(JsonData.clientSecret);

    let formattedData = JSON.parse(JSON.stringify(JsonData)); // make a deep copy to work on

    formattedData.clientSecret = hideSecret(formattedData.clientSecret);

    setRowJsonData(formattedData);
    setMode('view');
    setReadOnly(true);
    setOpen(true);
  };

  const fetchData = async (apiURL2, qparams) => {
    setIsloading(true);
    await fetchAPIData(apiURL2, qparams)
      .then((data) => {
        setApiData(data);
        setIdpOAuth2(data);
        // clear the reload false now that data is loaded
        setReload(false);
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);

        let message = `Failed to load IDP OAuth2 data \n\n ${err.response.statusText} : ${err.response.data.message}`;
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });

        setReload(false);
        setIsloading(false);
      });

  }

  const handleJsonChange = (formData) => {
    // console.log("Dialog JSON has changed", formData);

    setRowJsonData(formData);
  };

  const handleConfirmClose = () => {
    setConfirmOpen(false);
  };

  const handleFormChange = (data) => {
    setRowJsonData(data.formData);
  };

  const validateSchema = (systemSchema, data) => {
    const validate = ajv.compile(systemSchema);
    const valid = validate(data);
    if (!valid) {
      console.log(validate.errors);
      return false;
    }
    return true;
  }

  const saveSystemIdpOAuthData = (formData) => {
    // react json form generates an empty object when nothing set.
    // This is causing issues in backend API when fields are validated for blank (especially eventTopics)
    let cleanedObj = cleanObject(formData);

    if (mode === 'edit') {
      if (validateSchema(systemIdpOAuth2SchemaUpdate, cleanedObj)) {
        updateSystemIdpOAuthData(cleanedObj);
      }
      else {
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: "update schema validation failed.",
          severity: 'error'
        });

      }
    }
    if (mode === 'create') {
      if (validateSchema(systemIdpOAuth2SchemaRequired, cleanedObj)) {
        createSystemIdpOAuthData(cleanedObj);
      }
      else {
        console.log('create schema validation failed for required params..');
        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: 'create schema validation failed for required params..',
          severity: 'error'
        });
      }
      setOpenIdpOAuth(false);
    }
  }

  const updateSystemIdpOAuthData = (data) => {
    try {

      // password not changed so send original client secret
      if (data.clientSecret === HIDDEN_SECRET) {
        data.clientSecret = originalClientSecret;
      }

      axios({ method: "put", url: '/api/idps/oauth2/' + data.companyId, data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            // console.log('got response from system idp oauth2  update:', response);
            let message = `System IDP OAuth2 updated successfully for company ID [${data.companyId}]`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });
            setReload(true);
            setOpen(false);
          }

        }).catch(error => {
          let message = `Failed to update IDP OAuth2 for company ID [${data.companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;
          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
        });
    }
    catch (e) {
      console.log(e);
    }
  }

  const createSystemIdpOAuthData = (data) => {
    try {

      // password not changed so send original client secret
      if (data.clientSecret === HIDDEN_SECRET) {
        data.clientSecret = originalClientSecret;
      }

      axios({ method: "post", url: '/api/idps/oauth2', data: data, headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() } })
        .then(response => {
          if (response.status === 200) {
            let message = `Created IDP OAuth2 for company ID [${response.data.companyId}]`;

            setNotify({
              isOpen: true,
              message: message,
              severity: 'info'
            });

            setReload(true);
            setOpen(false);
          }
        }).catch(error => {
          console.log('error in create system idp oauth2 api call:', error.response.data.message);
          let message = `Failed to create IDP OAuth2 for company ID [${data.companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;
          setNotify({
            isOpen: true,
            alertTitle: 'Request failed',
            message: message,
            severity: 'error'
          });
        });
    }
    catch (e) {
      console.log(e);
      let message = `Failed to create IDP OAuth2 for company ID [${data.companyId}] `;
      setNotify({
        isOpen: true,
        alertTitle: 'Request failed',
        message: message,
        severity: 'error'
      });
    }
  }

  const deleteIdpOAuth2 = (companyId) => {
    let deleteUrl = `/api/idps/oauth2/${companyId}`

    axios({
      method: "delete", url: deleteUrl,
      headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    })
      .then(response => {
        let message = `Deleted IDP OAuth2 user for company ID [${companyId}]`;

        setNotify({
          isOpen: true,
          message: message,
          severity: 'info'
        });

        // do we need to reload??
        setApiData([]);
        setReload(true);

      }).catch(error => {

        let message = `Failed to delete IDP OAuth2 for company ID [${companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

        setNotify({
          isOpen: true,
          alertTitle: 'Request failed',
          message: message,
          severity: 'error'
        });
      });
  };

  const deleteRowData = useCallback((rowData) => () => {

    let companyId = rowData.companyId;
    let title = "Delete IDP Oauth2";
    let confirmButtonText = "Yes";
    let cancelButtonText = "No";
    let msg = `The IDP OAuth2 Company ID ${rowData.companyId} will be removed. Are you sure?`;

    let confirmProps = {
      title,
      msg,
      confirmButtonText,
      cancelButtonText,
      confirmCallback: () => deleteIdpOAuth2(companyId)
    };


    setConfirmProps(confirmProps);

    setConfirmOpen(true);
  }, []);

  return (
    <>
      <div id="filterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
        <Filter permission={platformPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL='/api/idps/oauth2?' fetchData={fetchData} useCompanyId={false} totalLabel={totalLabel} reload={reload} tabName={'idpOauthTab'} />
      </div>


      <Divider />

      <div id="idpOAuthContainer" className={toggleColumnPinning()}>
        <div >
          <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
        </div>
      </div>


      <ActionDialog
        open={open}
        mode={mode}
        onClose={handleClose}
        onSave={() => handleSave(formId, rowJsonData, saveSystemIdpOAuthData)}
        title="IDP OAuth Information"
        propertiesTabContent={
            <SystemDialog formId={formId}
              uiSchema={uiSchema}
              systemSchema={mode === 'create' ? systemIdpOAuth2SchemaRequired : systemIdpOAuth2SchemaUpdate}
              saveSystemData={saveSystemIdpOAuthData}
              formData={rowJsonData}
              handleFormChange={handleFormChange}
              readOnly={readOnly}
            />
        }
        jsonDataName="idpOAuth2"
        JSONTabContent={rowJsonData}
        handleJsonChange={handleJsonChange}
      />

      <ConfirmDialog
        title={confirmProps.title}
        open={confirmOpen}
        onClose={handleConfirmClose}
        setOpen={setConfirmOpen}
        cancelButtonText={confirmProps.cancelButtonText}
        confirmButtonText={confirmProps.confirmButtonText}
        onConfirm={confirmProps.confirmCallback}
      >
        {confirmProps.msg}
      </ConfirmDialog>

    </>
  );
}

export default SystemIdpOAuthTabPanel;